const getYearsLabel = (count) => {
  if (count === 1) return 'Year';
  if (count >= 2 && count <= 4) return 'Years';
  return 'byYears';
};

export default getYearsLabel;
